"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = setup;

var _TranscriptPopup = require("TranscriptPopup");

var _clapprHlsFix = require("clappr-hls-fix");

function setup(_ref) {
  var videoSrc = _ref.videoSrc,
      posterSrc = _ref.posterSrc,
      trackPath = _ref.trackPath,
      trackID = _ref.trackID,
      overrides = _ref.overrides,
      tool = _ref.tool,
      id = _ref.id;
  var Options = {
    width: 800,
    height: 450,
    autoPlay: false,
    source: videoSrc,
    poster: posterSrc
  };
  Object.assign(Options, overrides);
  attach();

  function played() {
    $('.header-item.video').addClass('started'); // FIXME: BLX.trackObjectView(tool, 'record', id);
  }

  function attach() {
    var Player = (0, _clapprHlsFix.getFixedClappr)(Options);
    var lastRange = {
      start: 0,
      end: 0
    };
    var trackInterval;
    $('#video-player').data('player', Player);
    Player.attachTo($('#video-player')[0]);
    if (Options.autoPlay) played();else Player.once('play', played);
    Player.on('play', play);
    Player.on('seek', seek);
    Player.on('timeupdate', timeupdate);
    Player.on('pause', track);
    Player.on('ended', track);
    Player.on('stop', track);
    $(window).on('unload', track);

    if (Options.transcript) {
      $('#video-player').append("\n\t\t\t\t<div class='transcript-button-wrapper'>\n\t\t\t\t\t<a class='transcript-button' href='javascript:void(0)'>Transcript</a>\n\t\t\t\t</div>\n\t\t\t");
      $('#video-player a.transcript-button').on('click', function () {
        (0, _TranscriptPopup.show)(Options.transcript.title, Options.transcript.transcript, $('#video-player')[0]);
      });
    }

    function track() {
      var r = lastRange;

      if (r.start != r.end) {
        var e = encodeURIComponent;
        var tgt = trackPath + '?' + Object.keys(r).map(function (k) {
          return e(k) + '=' + e(String(r[k]));
        }).join('&');
        $.get(tgt, function () {});
      }

      lastRange = {
        start: r.start,
        end: r.end
      };
    }

    function play() {
      clearInterval(trackInterval);
      trackInterval = setInterval(track, 10 * 1000);
    }

    function seek(tgt) {
      track();
      lastRange.start = lastRange.end = tgt;
    }

    function timeupdate(progress) {
      lastRange.end = progress.current;
    }

    function pause() {
      track();
    }
  }
}